module.exports = __webpack_public_path__ + "static/media/wordpress-migration-br.5d1be7d7.png";